module.exports = __webpack_public_path__ + "img/ep-R.2b6ab84e.jpg";